import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
import React, {Fragment, useState} from "react";
import {Form} from "react-bootstrap";
import {FormGroup, Label, Input, CardBody, Modal} from 'reactstrap';

const ConfirmDeleteModal = ({onHide,show,deleteReport}) => {

    const [AllowDelete,SetDelete] = useState(true)

  return (
    <Modal  isOpen={show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
           style={{opacity:1}}
    >
      <div className="modal-header">
        <h5 id="contained-modal-title-vcenter">
          Czy na pewno chcesz usunąć sprawozdanie?
        </h5>
      </div>
      {/* <div className="modal-body">
        <FormGroup className="pb-2 justify-content-md-center" check className='wskaznikiCheckBox'>
          <Label check>
            <Input type="checkbox" name="deleteModal" id="deleteModal" onClick={() => SetDelete(!AllowDelete)}
                            />
            <span className="form-check-sign"/>
            Potwierdź usunięcie sprawozdania
          </Label>
      </FormGroup>
      </div> */}
      <div className="modal-footer">
      <div className="left-side">
        <Button className='btn-link' type='button'  variant='danger' disabled={!AllowDelete} onClick={e=>{deleteReport();SetDelete(true);onHide();}}>Usuń</Button>
      </div>
      <div className="divider" style={{width:"2px"}}/>
      <div className="right-side">
        <Button className='btn-link' type='button' color='wskazniki' onClick={e=>{SetDelete(true);onHide();}}>Anuluj</Button>
      </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal